/**
 * Politique de confidentialité — page publique, sans dépendance à la session.
 *
 * Pointée par `mcp/README.md` § Contact et confidentialité (standard MCP MCP-U4) et soumise au
 * Claude Directory. Le texte vit dans les locales (`confidentialite.sections.*`, FR/EN miroir) ;
 * chaque rubrique est un titre, des paragraphes (`p`) et/ou une liste (`items`).
 */

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Eyebrow, PageHeader } from '../components/common.jsx';

/** Ordre des rubriques — chaque identifiant a son entrée dans `confidentialite.sections`. */
export const RUBRIQUES = [
  'controller',
  'data',
  'purposes',
  'studio',
  'legalBasis',
  'processors',
  'mcp',
  'transfers',
  'retention',
  'rights',
  'cookies',
  'security',
  'changes',
];

function Rubrique({ id }) {
  const { t } = useTranslation();
  const base = `confidentialite.sections.${id}`;
  const paragraphes = t(`${base}.p`, { returnObjects: true, defaultValue: [] });
  const items = t(`${base}.items`, { returnObjects: true, defaultValue: [] });

  return (
    <section className="relative border-2 border-line bg-paper p-4" aria-labelledby={`rub-${id}`}>
      <span className="ticks" aria-hidden="true" />
      <Eyebrow as="h2" className="mb-2">
        <span id={`rub-${id}`}>{t(`${base}.title`)}</span>
      </Eyebrow>
      {Array.isArray(paragraphes) &&
        paragraphes.map((texte) => (
          <p key={texte} className="mt-2 text-sm text-ink-soft">
            {texte}
          </p>
        ))}
      {Array.isArray(items) && items.length > 0 && (
        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-ink-soft">
          {items.map((texte) => (
            <li key={texte}>{texte}</li>
          ))}
        </ul>
      )}
      {id === 'mcp' && (
        <p className="mt-3 text-sm text-ink-soft">
          <Link to="/aide-mcp" className="underline">
            {t('confidentialite.mcpDocLink')}
          </Link>
        </p>
      )}
    </section>
  );
}

export function ConfidentialitePage() {
  const { t } = useTranslation();

  return (
    <div>
      <PageHeader
        eyebrow={t('confidentialite.eyebrow')}
        title={t('confidentialite.title')}
        subtitle={t('confidentialite.updated')}
      />
      <div className="mx-auto flex max-w-3xl flex-col gap-4 p-6">
        <p className="text-sm text-ink-soft">{t('confidentialite.intro')}</p>
        {RUBRIQUES.map((id) => (
          <Rubrique key={id} id={id} />
        ))}
        <p className="text-sm text-ink-soft">
          {t('confidentialite.contactPrefix')}{' '}
          <a href="mailto:cedric@exidis.fr" className="underline">
            cedric@exidis.fr
          </a>
        </p>
      </div>
    </div>
  );
}
